import { Target, Eye, Heart } from "lucide-react";
import { BUSINESS, VALUES } from "@/data/cybernet";

export const About = () => {
  return (
    <section
      id="nosotros"
      data-testid="about-section"
      className="bg-white py-20 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <div className="uppercase text-xs font-bold tracking-[0.25em] text-[#E10600] mb-4">
              — Nosotros
            </div>
            <h2 className="font-display font-black text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tighter text-[#0A0A0A]">
              Desde
              <br />
              <span className="text-[#E10600]">{BUSINESS.since}.</span>
            </h2>
            <div className="mt-8 flex items-baseline gap-4">
              <div className="font-display font-black text-8xl text-[#0A0A0A] leading-none">
                20
              </div>
              <div className="text-sm uppercase tracking-widest text-[#52525B]">
                años de
                <br />
                experiencia
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 space-y-6">
            <div className="border-l-4 border-[#E10600] pl-6">
              <h3 className="font-display font-bold text-lg text-[#0A0A0A] mb-3 uppercase tracking-wide">
                Historia
              </h3>
              <p className="text-[#52525B] leading-relaxed text-base">
                CYBERNET Cortazar inició en el año 2004, con 20 años de
                experiencia en el mercado dedicados a satisfacer las necesidades
                en Tecnologías de la Información de nuestros clientes brindando
                siempre atención y servicio de calidad. Contamos con una amplia
                gama de productos para soluciones en tecnología de la
                información, servicios de reparación y mantenimiento de equipo
                de cómputo y sus accesorios, servicios de internet, impresión y
                trámites digitales.
              </p>
            </div>

            <div className="grid sm:grid-cols-2 gap-4">
              <div
                data-testid="mission-card"
                className="border border-[#E4E4E7] p-6 hover:border-[#E10600] transition-colors rounded-sm"
              >
                <Target className="h-6 w-6 text-[#E10600] mb-3" />
                <h4 className="font-display font-bold text-lg text-[#0A0A0A] mb-2">
                  Misión
                </h4>
                <p className="text-sm text-[#52525B] leading-relaxed">
                  Satisfacer las necesidades de nuestros clientes en el ámbito
                  de tecnologías de información, servicio y reparación de
                  equipo, así como todo tipo de trámites digitales e impresión.
                </p>
              </div>
              <div
                data-testid="vision-card"
                className="border border-[#E4E4E7] p-6 hover:border-[#E10600] transition-colors rounded-sm"
              >
                <Eye className="h-6 w-6 text-[#E10600] mb-3" />
                <h4 className="font-display font-bold text-lg text-[#0A0A0A] mb-2">
                  Visión
                </h4>
                <p className="text-sm text-[#52525B] leading-relaxed">
                  Ser una empresa reconocida a nivel local y en nuestra región
                  por nuestro excelente servicio, calidad y ser la opción número
                  uno de nuestros clientes.
                </p>
              </div>
            </div>

            <div className="bg-[#0A0A0A] text-white p-8 rounded-sm">
              <div className="flex items-center gap-3 mb-6">
                <Heart className="h-5 w-5 text-[#E10600]" />
                <h4 className="font-display font-bold text-lg uppercase tracking-wide">
                  Valores
                </h4>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-5 gap-4">
                {VALUES.map((v) => (
                  <div key={v.title} className="group">
                    <div className="font-display font-black text-base text-white mb-1">
                      {v.title}
                    </div>
                    <div className="h-[2px] w-6 bg-[#E10600] mb-2 transition-all group-hover:w-12" />
                    <p className="text-xs text-white/60 leading-relaxed">
                      {v.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
